import { useEffect, useState } from 'react';

import { useNavParams } from 'hooks';

import { Header, TabType } from '../types';

/**
 * This hook is responsible for the two levels navigation:
 *
 * 1. Level: tabIndex
 * 2. Level: tabbedElement
 *
 * It also listens to hash changes and sets the correct navigation element based on the result.
 */
const useTabNavigation = (
  defaultTabIndex: number,
  defaultTabbedElement: TabType,
  headers: Header[],
  views: TabType[]
) => {
  const [tabIndex, setTabIndex] = useState<number>(defaultTabIndex);
  const [tabbedElement, setTabbedElement] =
    useState<TabType>(defaultTabbedElement);

  const { params, setParams } = useNavParams();

  const defaultHeader = headers[defaultTabIndex];
  const defaultView =
    views.find((view) => view.parent === defaultHeader.subHeaderName) ??
    views[0];

  /* Listen on hash change and set the tabbed element based on that*/
  useEffect(() => {
    const tableView =
      views.find(
        (tableView) => tableView.name === params?.page?.toUpperCase()
      ) || defaultView;

    if (tableView) {
      setTabIndex(
        headers.findIndex(
          ({ subHeaderName }) => subHeaderName === tableView.parent
        )
      );
      setTabbedElement(tableView);
      if (tableView.id === defaultView.id)
        setParams({ page: tableView.name.toLowerCase() });
    }
  }, [params?.page]);

  return {
    tabbedElement,
    setTabbedElement,
    tabIndex,
    setTabIndex
  };
};

export default useTabNavigation;
